// tslint:disable:max-line-length

export const Grid = {
  cellWidth: 205,
  cellHeight: 200,
  marginX: 10,
  marginY: 5,
}
export const WSizing = {
  width(w: number): number {
    return Grid.cellWidth * w - Grid.marginX * 2
  },
  height(h: number): number {
    const headerHeight = 37
    return Grid.cellHeight * h - Grid.marginY * 2 - headerHeight
  },
}
export const WSize = {
  single: {
    w: 180,
    h: 158,
  },
  dbl: {
    w: 380,
    h: 362,
  },
  quad: {
    w: 780,
    h: 362,
  },
  headerHeight: 37,
}

export const FusionThemesDefault = "micad"

export const FusionThemes = [
  {theme: "micad", label: "Micad"},
  {theme: "fusion", label: "Fusion"},
  // {theme: "candy", label: "Candy"},
  // {theme: "carbon", label: "Carbon"},
  // {theme: "fint", label: "Fint"},
  // {theme: "gammel", label: "Gammel"},
  // {theme: "ocean", label: "Ocean"},
  // {theme: "umber", label: "Umber"},
  // {theme: "Zune", label: "Zune"},
]

export interface FCCategoryDef {
  [key: string]: string,
}

export interface FCCategoriesDef {
  [key: string]: FCCategoryDef
}

export enum FCCategory {
  KeyValue = "KeyValue",
  TimeSeries = "TimeSeries",
  Gauge = "Gauge",
  Custom = "Custom",
}

export const FusionChartTypes: FCCategoriesDef = {
  [FCCategory.KeyValue]: {
    pie2d: "Pie in 2D",
    pie3d: "Pie in 3D",
    doughnut2d: "Donut in 2D",
    doughnut3d: "Donut in 3D",
    bar2d: "Simple bar",
    bar3d: "Bar in 3D",
    column2d: "Column in 2D",
    column3d: "Column in 3D",
  },
  [FCCategory.TimeSeries]: {
    line: "Simple line",
    area2d: "Simple area",
    spline: "Simple spline",
    splinearea: "Simple spline-area",
    scrollline2d: "Scroll line 2D",
  },
  [FCCategory.Gauge]: {
    angulargauge: "Rating Meter",
    cylinder: "Cylinder fill",
  },
  [FCCategory.Custom]: {},
}

export interface WidgetFilterOptions {
  title: string,
  placeholder?: string,
  options?: Map<string, any> | Array<{ title: string, value: any }>,
  autocompleteFn?: string,
  autocompleteType?: string,
}

export interface WidgetParameter {
  _order: number,
  _inputType: string,
  value: any,
  _override?: boolean,
  _default?: any,
  _number?: boolean,
  _opts: WidgetFilterOptions,
}

export interface WidgetParameters {
  [key: string]: WidgetParameter,
}

export interface WidgetDefinition {
  i?: string,
  widget: any,
  title: string,
  _description?: string,
  theme?: string,
  x?: number,
  y?: number,
  w: number,
  h: number,
  _cTypes?: FCCategory,
  cType?: string,
  wc?: { id?: number, panelId: number, widgetName: string },
  position?: { x: number, y: number, w: number, h: number },
  params?: WidgetParameters,
  fusionChartParams?: FusionDisplayParams,
  componentPath?: string,
  _icon?: string,
}

export interface FusionDisplayParams {
  [key: string]: FusionDisplayParamsItem
}

export interface FusionDisplayParamsItem {
  _order: number,
  _inputType: string,
  value: any,
  _opts: {
    title: string,
    options: Map<string, object | string>,
  },
}

export interface WidgetCategoryDef {
  category: string,
  show: boolean,
  widgets: WidgetDefinition[],
  componentPath?: string, // falls back to componentPath in particular widget if unspecified, last resort: widgets dir
                          // in the WidgetCategoryDef path should end with a slash "/"
}

export const Widgets: WidgetCategoryDef[] = [
  {
    category: "Core charts", show: true, componentPath: "core/", widgets: [
      {widget: "LocationCount", title: "Locations count", w: 2, h: 2, _icon: "table"},
      {
        widget: "Last30DaysActivity",
        title: "User activity",
        w: 4,
        h: 2,
        _icon: "line",
      },
      {
        widget: "FloorsWithoutDrawings",
        title: "Floors With No (As Built) Drawings",
        w: 2,
        h: 2,
      },
      {
        widget: "RoomsWithoutFunctions",
        title: "Rooms without functions",
        w: 2,
        h: 2,
      },
      {widget: "ClashingRooms", title: "Clashing rooms", w: 1, h: 1, _icon: "text"},
      {widget: "NetInternalArea", title: "Net internal area, Sq.m", w: 2, h: 1, _icon: "text"},
//       {widget: "CarterMetrics", title: "Carter metrics", w: 4, h: 2},
//       {widget: "CarterMetricsClinical", title: "Carter metrics Clinical", w: 2, h: 2},
//       {widget: "CarterMetricsUtilisation", title: "Carter metrics Utilization", w: 2, h: 2},
//       {widget: "CarterClinicalTargetPercentage", title: "Carter metrics clinical - target 65%", w: 2, h: 1, _icon: "gauge"},
//       {widget: "CarterUtilizationTargetPercentage", title: "Carter metrics utilization - target 97.5%", w: 2, h: 1, _icon: "gauge"},
//       {
//         widget: "UniversalUserListBox",
//         title: "Room data",
//         w: 2,
//         h: 2,
//       },
      {
        widget: "RoomDataAgeProfile",
        title: "Room data age profile",
        w: 2,
        h: 2,
      },
      {
        widget: "AsBuiltDrawingsByDate",
        title: "As built drawings by date",
        w: 2,
        h: 2,
      },
      {
        widget: "GiaNia",
        title: "GIA and NIA",
        w: 2,
        h: 2,
      },
    ],
  },
  {
    category: "Appraisal charts", show: true, componentPath: "appraisal/", widgets: [
      {
        widget: "AppraisalRisk",
        title: "Appraisal risk",
        w: 2,
        h: 2,
      },
      {
        widget: "AppraisalResidualRisk",
        title: "Appraisal residual risk",
        w: 2,
        h: 2,
      },
      {
        widget: "AppraisalLifecycleCost",
        title: "Appraisal lifecycle cost",
        w: 4,
        h: 2,
        _icon: "line",
      },
      {
        widget: "AppraisalFacetScores",
        title: "Appraisal facet scores",
        w: 2,
        h: 2,
      },
    ],
  },
  {
    category: "Compliance charts", show: true, componentPath: "compliance/", widgets: [
      {
        widget: "ComplianceElementsWithNoLocations",
        title: "Compliance Elements With No Locations",
        w: 1,
        h: 1,
        _icon: "text",
      },
      {
        widget: "ComplianceLocationsWithNoElements",
        title: "Compliance locations With No Elements",
        w: 1,
        h: 1,
        _icon: "text",
      },
      {
        widget: "ComplianceElementsFailingIn30Days",
        title: "Compliance Elements Failing in 30 Days",
        w: 1,
        h: 1,
        _icon: "text",
      },
      {
        widget: "ComplianceFailingElements",
        title: "Compliance Failing Elements",
        w: 1,
        h: 1,
        _icon: "text",
      },
      {widget: "ComplianceOutstandingActions", title: "Outstanding actions", w: 1, h: 1, _icon: "text"},
      {widget: "ComplianceExpiredElements", title: "Expired Elements", w: 1, h: 1, _icon: "text"},
      {
        widget: "ComplianceOverallBuildingCompliance",
        title: "Overall building compliance",
        w: 2,
        h: 1,
        _icon: "bar",
      },
      {
        widget: "ComplianceWorstPerformingBuildings",
        title: "Worst Performing Buildings",
        w: 4,
        h: 2,
        _icon: "bar",
      },
      {
        widget: "ComplianceWorstPerformingElements",
        title: "Worst Performing Elements",
        w: 4,
        h: 2,
        _icon: "bar",
      },
      {
        widget: "ComplianceWorstPerformingOwners",
        title: "Worst Performing Owners",
        w: 4,
        h: 2,
        _icon: "bar",
      },
      {
        widget: "ComplianceSingleElementScore",
        title: "Single Element Score",
        w: 2,
        h: 1,
        _icon: "gauge",
      },
      {
        widget: "ComplianceElementScoreOverTime",
        title: "Score Over Time",
        w: 4,
        h: 2,
        _icon: "line",
      },
    ],
  },
  {
    category: "NHS specific charts", show: true, componentPath: "eric/", widgets: [
      {
        widget: "SpaceStatus",
        title: "Space status",
        w: 2,
        h: 2,
      },
      {
        widget: "AgeProfile",
        title: "Age profile by built date",
        w: 2,
        h: 2,
      },
      {
        widget: "CeilingHeights",
        title: "Ceiling heights",
        w: 4,
        h: 2,
        _icon: "line",
      },
      {
        widget: "FloorArea",
        title: "Lord Carter KPIs",
        w: 2,
        h: 2,
      },
      {
        widget: "Areas",
        title: "Areas",
        w: 2,
        h: 2,
      },
    ],
  },
  {
    category: "HD charts", show: true, componentPath: "hd/", widgets: [
      {
        widget: "HDInhouseStatutoryComplianceCompletedForMonthToDate",
        title: "In-house statutory compliance completed for month to date",
        w: 2,
        h: 2,
      },
      {
        widget: "HDInhouseReactiveJobsAllocatedForMonthToDate",
        title: "In-house reactive jobs allocated for month to date",
        w: 2,
        h: 2,
      },
      {
        widget: "JobsAllocatedInAMonthPPMJobsCompleted",
        title: "In-house PPM jobs completed for month to date",
        w: 2,
        h: 1,
        _icon: "text",
      },
      {
        widget: "JobsRaisedInAMonth",
        title: "Reactive Job lines raised for month to date",
        w: 2,
        h: 1,
        _icon: "text",
      },
      {
        widget: "PMJobsRaisedInAMonth",
        title: "PPM jobs raised for month to date",
        w: 2,
        h: 1,
        _icon: "text",
      },
      {widget: "JobsRaisedToday", title: "Jobs raised today", w: 2, h: 1, _icon: "text"},
      {widget: "JobsRaisedThisMonth", title: "Jobs raised this month", w: 2, h: 1, _icon: "text"},
      {widget: "JobsRaisedThisYear", title: "Jobs raised this year", w: 2, h: 1, _icon: "text"},
      {
        widget: "JobsRaisedFinancialYear",
        title: "Reactive jobs raised in current financial year",
        w: 2,
        h: 1,
        _icon: "text",
      },
      {
        widget: "HDTopFiveFaultsForMonthToDate",
        title: "Top 5 faults for month to date",
        w: 4,
        h: 2,
        _icon: "column",
      },
      {
        widget: "HDTopFiveBuildingsForMonthToDate",
        title: "Top 5 buildings for month to date",
        w: 4,
        h: 2,
        _icon: "column",
      },
      {
        widget: "HDJobsForYearToDate",
        title: "Jobs for year to date",
        w: 4,
        h: 2,
        _icon: "column",
      },
      {
        widget: "HDJobsAllocatedForMonthToDate",
        title: "Reactive Job lines allocated for month",
        w: 2,
        h: 2,
      },
    ],
  },
  {
    category: "Audit charts", show: true, componentPath: "audit/", widgets: [
      {
        widget: "CompleteAuditScore",
        title: "Complete audit score",
        w: 2,
        h: 2,
      },
      {
        widget: "AuditFailureByResponsibilityGroup",
        title: "Failure by responsibility group",
        w: 4,
        h: 2,
        _icon: "column",
      },
      {
        widget: "AuditConsistentlyFailingElements",
        title: "Consistently Failing Elements",
        w: 4,
        h: 2,
        _icon: "table",
      },
      {widget: "AuditRoomsNotAudited", title: "Rooms not audited", w: 2, h: 1, _icon: "text"},
      {
        widget: "AuditRoomStatus",
        title: "Audited room status",
        w: 2,
        h: 2,
      },
      {
        widget: "AuditActiveAuditsByTeam",
        title: "Active Audits By Team",
        w: 4,
        h: 2,
        _icon: "table",
      },
      {
        widget: "AuditOverdueOutstandingActions",
        title: "Overdue outstanding actions",
        w: 4,
        h: 2,
        _icon: "column",
      },
      {
        widget: "AuditMostCommonNoAccessReasons",
        title: "Most common no access reasons",
        w: 2,
        h: 2,
      },
    ],
  },
]

export function getWidgetMap(wc: WidgetCategoryDef[] = Widgets): Map<string, WidgetDefinition> {
  const wMap = new Map<string, WidgetDefinition>()
  for (const cat of wc) {
    cat.widgets.reduce((result, item) => result.set(item.widget, item), wMap)
  }
  return wMap
}

export const DNDPlaceholder = {widget: "DNDPlaceholder", title: "Locations count", w: 2, h: 2, cTypes: []}

export interface WidgetIconsDef {
  [key: string]: string,
}

export const WidgetIcons: WidgetIconsDef = {
  gauge: "widgetIcon-gauge36x36.png",
  column: "widgetIcon-column36x36.png",
  table: "widgetIcon-table36x36.png",
  line: "widgetIcon-line36x36.png",
  pie: "widgetIcon-pie36x36.png",
  bar: "widgetIcon-bar36x36.png",
  text: "widgetIcon-number36x36.png",
}

export const WConfTpl = {
  Numeric() {
    return {
      widget: "",
      title: "",
      w: 2,
      h: 1,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.Custom,
      params: {},
    }
  },
  Bar2D() {
    return {
      widget: "",
      title: "",
      w: 2,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.Custom,
      cType: "bar2d",
    }
  },
  Column2D() {
    return {
      widget: "",
      title: "",
      w: 2,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.KeyValue,
      cType: "column2d",
    }
  },
  KeyValue() {
    return {
      widget: "",
      title: "",
      w: 2,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.KeyValue,
      cType: "pie2d",
      params: {},
    }
  },
  Doughnut2D() {
    return {
      widget: "",
      title: "",
      w: 2,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.Custom,
      cType: "doughnut2d",
      params: {},
    }
  },
  Gauge() {
    return {
      widget: "",
      title: "",
      w: 2,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.Custom,
      cType: "angulargauge",
    }
  },
  Line() {
    return {
      widget: "",
      title: "",
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.TimeSeries,
      cType: "line",
      params: {},
    }
  },
  MultiLevelPie() {
    return {
      widget: "",
      title: "",
      w: 2,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.Custom,
      cType: "multilevelpie",
    }
  },
  ScrollBar2D() {
    return {
      widget: "",
      title: "",
      w: 2,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.Custom,
      cType: "scrollbar2d",
    }
  },
  ScrollLine2D() {
    return {
      widget: "",
      title: "",
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.Custom,
      cType: "scrollline2d",
      params: {},
    }
  },
  StackedBar2D() {
    return {
      widget: "",
      title: "",
      w: 2,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.Custom,
      cType: "stackedbar2d",
    }
  },
  TimeSeries() {
    return {
      widget: "",
      title: "",
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.TimeSeries,
      cType: "line",
      params: {},
    }
  },
  Table() {
    return {
      widget: "",
      title: "",
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.Custom,
      cType: "table",
      params: {},
    }
  },
  Text() {
    return {
      widget: "",
      title: "",
      w: 2,
      h: 1,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.Custom,
      cType: "text",
      params: {},
    }
  },
  ZoomLine() {
    return {
      widget: "",
      title: "",
      w: 4,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.Custom,
      cType: "zoomline",
      params: {},
    }
  },
  Custom() {
    return {
      widget: "",
      title: "",
      w: 2,
      h: 2,
      x: 0,
      y: 0,
      theme: "micad",
      _cTypes: FCCategory.Custom,
      // cType: "", // please override
      params: {},
    }
  },
}

export const WParamTpl = {
  locationId() {
    return {
      _order: 1,
      _inputType: "InputLocation",
      value: "10",
      _number: false,
      _opts: {
        title: "Location ID",
        placeholder: "Start typing to get suggestions",
        autocompleteFn: "locationAutocomplete",
        autocompleteType: "AutocompleteLocation",
      },
    }
  },
  regionId() {
    return {
      _order: 1,
      _inputType: "InputLocation",
      value: "10",
      _number: false,
      _opts: {
        title: "Region ID",
        placeholder: "Start typing to get suggestions",
        autocompleteFn: "locationAutocompleteRegion",
        autocompleteType: "AutocompleteLocation",
      },
    }
  },
  Appraisal() {
    return {
      _order: 1,
      _inputType: "InputCascaded",
      value: {},
      _number: false,
      _opts: {
        title: "Appraisal selector",
        placeholder: "Start typing to get suggestions",
        layout: [
          {name: "survey", title: "Survey", autocompleteFn: "surveyAutocomplete"},
          {name: "survey_facets", title: "Facets", autocompleteFn: "facetsAutocomplete"},
          {name: "facet_categories", title: "Category", autocompleteFn: "categoryAutocomplete"},
          {name: "category_elements", title: "Elements", autocompleteFn: "elementsAutocomplete"},
          {name: "element_subelements", title: "Sub Elements", autocompleteFn: "subelementsAutocomplete"},
        ],
      },
    }
  },
  userId() {
    return {
      _order: 1,
      _inputType: "InputString",
      value: "1",
      _number: false,
      _opts: {
        title: "User ID",
        placeholder: "Start typing to get suggestions",
        autocompleteFn: "userIdAutocomplete",
        autocompleteType: "AutocompleteGeneric",
      },
    }
  },
  datePeriod() {
    return {
      _order: 1,
      _inputType: "InputEnum",
      _default: {title: "Last 30 days", value: "30d"},
      value: undefined,
      _number: false,
      _opts: {
        title: "Date period",
        options: [
          {title: "Week to date", value: "wtd"},
          {title: "Last 7 days", value: "7d"},
          {title: "Last 14 days", value: "14d"},
          {title: "Month to date", value: "mtd"},
          {title: "Last 30 days", value: "30d"},
          {title: "Last 90 days", value: "90d"},
          {title: "Last 180 days", value: "180d"},
          {title: "Year to date", value: "ytd"},
          {title: "Last 365 days", value: "365d"},
        ],
      },
    }
  },
  auditPeriod() {
    return {
      _order: 1,
      _inputType: "InputEnumMap",
      value: "1y",
      _number: false,
      _opts: {
        title: "Period",
        options: new Map<string, string>([
          ["Last 13 weeks", "91d"],
          ["Year to date", "ytd"],
          ["Last 12 months", "1y"],
        ]),
      },
    }
  },
  complianceElementId() {
    return {
      _order: 1,
      _inputType: "InputEnum",
      value: {title: "<Not set>", value: 0},
      _number: false,
      _opts: {
        title: "Element ID",
        options: [
          {title: "<Not set>", value: 0},
        ],
        autocompleteFn: "complianceElementList",
      },
    }
  },
  hdPPMRepairAll() {
    return {
      _order: 1,
      _inputType: "InputEnum",
      value: {title: "Repair", value: 2},
      _opts: {
        title: "Job type",
        options: [
          {title: "PPM", value: 1},
          {title: "Repair", value: 2},
          {title: "All", value: 0},
        ],
      },
    }
  },
  hdPPMRepair() {
    return {
      _order: 1,
      _inputType: "InputEnum",
      value: {title: "Repair", value: 2},
      _opts: {
        title: "Job type",
        options: [
          {title: "PPM", value: 1},
          {title: "Repair", value: 2},
        ],
      },
    }
  },
  hdCategory() {
    return {
      _order: 1,
      _inputType: "InputEnum",
      value: {title: "<All>", value: "0"},
      _number: false,
      _opts: {
        title: "Category",
        options: [
          {title: "<All>", value: "0"},
        ],
        autocompleteFn: "hdCategoryIdAutocomplete",
      } as WidgetFilterOptions,
    }
  },
  hdJobCategory() {
    return {
      _order: 1,
      _inputType: "InputEnum",
      value: {title: "<All>", value: "0"},
      _number: false,
      _opts: {
        title: "Category",
        options: [
          {title: "<All>", value: "0"},
        ],
        autocompleteFn: "hdJobCategoryList",
      } as WidgetFilterOptions,
    }
  },
  hdContractor() {
    return {
      _order: 1,
      _inputType: "InputEnum",
      value: {title: "In-house", value: "69"}, // default value
      _number: false,
      _opts: {
        title: "Contractor",
        options: [
          {title: "In-house", value: "69"},
          {title: "Skanska", value: "29"},
        ],
      } as WidgetFilterOptions,
    }
  },
  // @status int,		-- 0 = Not Completed / Outstanding, 1 = Done / Completed, 2 == ALL
  hdStatus() {
    return {
      _order: 1,
      _inputType: "InputEnum",
      value: {title: "All", value: 2}, // default value
      _number: false,
      _opts: {
        title: "Status",
        options: [
          {title: "Not Completed / Outstanding", value: 0},
          {title: "Done / Completed", value: 1},
          {title: "All", value: 2},
        ],
      } as WidgetFilterOptions,
    }
  },
  auditCategory() {
    return {
      _order: 1,
      _inputType: "InputEnum",
      value: "",
      _number: false,
      _opts: {
        title: "Category",
        options: [
          {title: "<All>", value: ""},
        ],
        autocompleteFn: "auditCategoryAutocomplete",
      } as WidgetFilterOptions,
    }
  },
}

export const FusionDisplayConfTpl = {
  numberFormatting() {
    return {
      _order: 1,
      _inputType: "InputEnumMap",
      value: "Default",
      _opts: {
        title: "Number formatting",
        options: new Map<string, object>([
          ["Default", {
            formatNumber: "0",
            formatNumberScale: "0",
            numberPrefix: "",
            numberSuffix: "",
            decimalSeparator: ".",
            thousandSeparator: ",",
            decimals: "2",
            forceDecimals: "0",
            showPercentValues: "0",
          }],
/*
          ["Money", {
            formatNumber: "1",
            formatNumberScale: "0",
            numberPrefix: "£",
            numberSuffix: "",
            decimalSeparator: ".",
            thousandSeparator: ",",
            decimals: "2",
            forceDecimals: "0",
            showPercentValues: "0",
          }],
          ["Money2", {
            formatNumber: "1",
            formatNumberScale: "0",
            numberPrefix: "£",
            numberSuffix: "",
            decimalSeparator: ".",
            thousandSeparator: ",",
            decimals: "2",
            forceDecimals: "1",
            showPercentValues: "0",
          }],
*/
          ["Percentage", {
            formatNumber: "1",
            formatNumberScale: "0",
            numberPrefix: "",
            numberSuffix: "",
            decimalSeparator: ".",
            thousandSeparator: ",",
            decimals: "0",
            forceDecimals: "0",
            showPercentValues: "1",
          }],
        ]),
      },
    } as FusionDisplayParamsItem
  },
}

export const FCConfTpl = () => {
  return {
    title: "",
    type: "",
    width: 0,
    height: 0,
    chartDataFormat: "json",
  }
}

export const ChartDataTemplate = () => {
  return {
    caption: "",
    subCaption: "",
    captionOnTop: "0",
    yAxisName: "",
    xAxisName: "",
    numberSuffix: "",
    rotateLabels: "1",
    setAdaptiveYMin: "1",
    theme: "micad",
    showLegend: "1",
    labelDisplay: "none",
    showLabels: "0",
    showValues: "1",
    legendCaption: "",
    animation: "0",
    usePlotGradientColor: "0",
    enableSlicing: "0",
    use3DLighting: "0",
  }
}
